import { Flex, mediaMixin, spaceMixin } from '@zillow/constellation';
import styled, { css } from 'styled-components';

export const StyledActions = styled(Flex)`
  max-height: 28px;
  padding: 0;
  margin-top: ${spaceMixin('1.75')};

  ${(props) =>
    !props.$showStackedView &&
    css`
      ${mediaMixin(
        'md',
        css`
          align-self: center;
          margin-left: auto;
          margin-top: 0;
        `,
      )}
    `}
`;
